import clientAuth from "../clientAuth";

export default {
  index: () => clientAuth.get("blog/index"),
  
  store: (userData) => clientAuth.post('blog/store', { json: userData }),
  

  show:(id)=>clientAuth.get('blog/show/'+id),

  update:(id,userData)=>clientAuth.post(`blog/update/${id}`,{json:userData}),

  destroy:(id)=>clientAuth.delete(`blog/destroy/${id}`),
};